import api from '../api/axios';

export const insuranceCompanyService = {
  async getAll() {
    // Don't populate relations for list view - much faster
    const response = await api.get('/insurance-companies');
    return response.data.data;
  },

  async getOne(id: number) {
    const response = await api.get(`/insurance-companies/${id}?populate=*`);
    return response.data.data;
  },

  async create(data: any) {
    const response = await api.post('/insurance-companies', { data });
    return response.data.data;
  },

  async update(id: number, data: any) {
    const response = await api.put(`/insurance-companies/${id}`, { data });
    return response.data.data;
  },

  async delete(id: number) {
    const response = await api.delete(`/insurance-companies/${id}`);
    return response.data;
  }
};

